import { render, staticRenderFns } from "./SortColumn.vue?vue&type=template&id=388626c4&scoped=true&"
import script from "./SortColumn.vue?vue&type=script&lang=js&"
export * from "./SortColumn.vue?vue&type=script&lang=js&"
import style0 from "./SortColumn.vue?vue&type=style&index=0&id=388626c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388626c4",
  null
  
)

export default component.exports